import knex, { Knex } from 'knex';
import { Config } from '@backstage/config';
import { Logger } from 'winston';

export class DevLakeDatabase {
  private readonly client: Knex;

  constructor(config: Config, logger: Logger) {
    const dbConfig = config.getConfig('doraMetrics.database');
    const connection = {
      host: dbConfig.getString('connection.host'),
      port: dbConfig.getNumber('connection.port'),
      user: dbConfig.getString('connection.user'),
      password: dbConfig.getString('connection.password'),
      database: dbConfig.getString('connection.database'),
    };

    logger.info('Creating connection to Apache DevLake database');
    
    this.client = knex({
      client: 'mysql2',
      connection,
      pool: {
        min: 2,
        max: 10,
      },
    });
  }

  async testConnection(): Promise<boolean> {
    try {
      await this.client.raw('SELECT 1');
      return true;
    } catch (error) {
      return false;
    }
  }

  getClient(): Knex {
    return this.client;
  }

  async listTables(): Promise<string[]> {
    const result = await this.client.raw('SHOW TABLES');
    return result[0].map((row: any) => Object.values(row)[0] as string);
  }

  async describeTable(tableName: string): Promise<any[]> {
    const result = await this.client.raw(`DESCRIBE ${tableName}`);
    return result[0];
  }
}
